enum EIndividual {
  INDIVIDUAL = 'individual',
  SELF_EMPLOYED = 'self_employed',
  INDIVIDUAL_ENTREPRENEUR = 'individual_entrepreneur',
}

export default EIndividual;
